import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  downloadPdf, initializeSections, initializeSummaryCameras, saveConfiguration, setPopupState, updateSections,
} from '../../model/configuratorSlice';
import SummarySectionsListMobile from './SummarySectionsListMobile';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import DownloadPdfService from '../../services/DownloadPdfService';
import { PopupState } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const SummaryPanelMobile = () => {
  const {
   settings, isSummaryOpened, summaryShots, user, isPublic,
  } = useSelector(state => state.configurator);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const saveConfigurationMutation = SaveConfigurationService();
  const downloadPdfMutation = DownloadPdfService();
  const dispatch = useDispatch();

  const isUserLoggedIn = () => user !== null && user.isLoggedIn;

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    if (isSummaryOpened) {
      dispatch(initializeSummaryCameras());
      dispatch(updateSections());

      if (summaryShots != null && summaryShots.length === 2) {
        setTopShot(summaryShots[0]);
        setBottomShot(summaryShots[1]);
      }
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  return (
    <div className={`summary-panel-mobile ${isSummaryOpened ? 'opened' : ''}`}>
      <div className="summary-content">


        <SummarySectionsListMobile />
        <div className={`summary-buttons-container${isUserLoggedIn() ? ' logged-in' : ''}`}>
          {isUserLoggedIn() ? (
            <button
              className="request-budget-button"
              type="button"
              hidden={isPublic}
              onClick={() => dispatch(setPopupState(PopupState.RequestBudget))}
            >
              {TranslationUtility.GetFormattedMessageForUI('ui-summary-request-budget-button', 'Formalizar')}
            </button>
          ) : null }
          <button
            className="save-button"
            type="button"
            hidden={isPublic}
            onClick={() => {
              saveConfigurationMutation.mutate();
              dispatch(saveConfiguration());
            }}
          >
            {TranslationUtility.GetFormattedMessageForUI('ui-summary-save-budget-button', 'Guardar')}
          </button>
          <button
            className="download-button"
            type="button"
            onClick={() => {
              downloadPdfMutation.mutate();
              dispatch(downloadPdf());
            }}
          >
            {TranslationUtility.GetFormattedMessageForUI('ui-summary-download-pdf-button', 'Descargar Resumen')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryPanelMobile;
